'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, useRef } from 'react';
import Image from '@/components/Image';
import { TeamSectionDto } from '@/components/service-pages/TeamSection/types';
import { useTeamSlider } from '@/components/service-pages/TeamSection/useTeamSlider';
import SliderNavButtons from '@/components/shared/SliderNavButtons';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import css from './style.module.scss';
interface Props {
  data: TeamSectionDto;
}
const TeamSection: FC<Props> = t0 => {
  const $ = _c(52);
  const {
    data
  } = t0;
  const {
    members,
    title
  } = data;
  const viewportRef = useRef(null);
  const trackRef = useRef(null);
  let t1;
  if ($[0] !== members.length) {
    t1 = {
      slideCount: members.length,
      viewportRef,
      trackRef
    };
    $[0] = members.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    activeIndex,
    goToSlide,
    onPointerDown,
    onPointerMove,
    onPointerUp,
    onPointerCancel
  } = useTeamSlider(t1);
  if (!members?.length) {
    return null;
  }
  const active = members[activeIndex] ?? members[0];
  const hasMultipleMembers = members.length > 1;
  const isFirst = activeIndex <= 0;
  const isLast = activeIndex >= members.length - 1;
  let t2;
  if ($[2] !== activeIndex || $[3] !== goToSlide || $[4] !== isFirst) {
    t2 = () => {
      if (isFirst) {
        return;
      }
      goToSlide(activeIndex - 1);
    };
    $[2] = activeIndex;
    $[3] = goToSlide;
    $[4] = isFirst;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onClickPrevious = t2;
  let t3;
  if ($[6] !== activeIndex || $[7] !== goToSlide || $[8] !== isLast) {
    t3 = () => {
      if (isLast) {
        return;
      }
      goToSlide(activeIndex + 1);
    };
    $[6] = activeIndex;
    $[7] = goToSlide;
    $[8] = isLast;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const onClickNext = t3;
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = clsx(css.section, "container");
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== title) {
    t5 = <Typography uppercase={true} className={css.title} variant="h2" tag="h2"><StrapiRichContent content={title} /></Typography>;
    $[11] = title;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== active.role) {
    t6 = active.role ? <span>{`, ${active.role}`}</span> : null;
    $[13] = active.role;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== active.name || $[16] !== t6) {
    t7 = <Typography className={css.memberName} variant="h6" tag="p">{active.name}{t6}</Typography>;
    $[15] = active.name;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== active.description) {
    t8 = active.description ? <Typography variant="body-s" tag="p" className={css.memberDescription}>{active.description}</Typography> : null;
    $[18] = active.description;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <div aria-live="polite">{t7}{t8}</div>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t5 || $[24] !== t9) {
    t10 = <div className={css.content}>{t5}{t9}</div>;
    $[23] = t5;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== members) {
    t11 = members.map(_temp);
    $[26] = members;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11) {
    t12 = <ul ref={trackRef} className={css.track} role="list">{t11}</ul>;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== onPointerCancel || $[31] !== onPointerDown || $[32] !== onPointerMove || $[33] !== onPointerUp || $[34] !== t12) {
    t13 = <div className={css.sliderWrap}><div ref={viewportRef} className={css.viewport} role="region" aria-roledescription="carousel" onPointerDown={onPointerDown} onPointerMove={onPointerMove} onPointerUp={onPointerUp} onPointerCancel={onPointerCancel}>{t12}</div></div>;
    $[30] = onPointerCancel;
    $[31] = onPointerDown;
    $[32] = onPointerMove;
    $[33] = onPointerUp;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== hasMultipleMembers || $[37] !== isFirst || $[38] !== isLast || $[39] !== onClickNext || $[40] !== onClickPrevious) {
    t14 = hasMultipleMembers ? <SliderNavButtons className={css.sectionNavButtons} previousDisabled={isFirst} nextDisabled={isLast} onPrevious={onClickPrevious} onNext={onClickNext} /> : null;
    $[36] = hasMultipleMembers;
    $[37] = isFirst;
    $[38] = isLast;
    $[39] = onClickNext;
    $[40] = onClickPrevious;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      display: "none"
    };
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== members) {
    t16 = members.map(_temp2);
    $[43] = members;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== t16) {
    t17 = <div style={t15}>{t16}</div>;
    $[45] = t16;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== t10 || $[48] !== t13 || $[49] !== t14 || $[50] !== t17) {
    t18 = <section className={t4}>{t10}{t13}{t14}{t17}</section>;
    $[47] = t10;
    $[48] = t13;
    $[49] = t14;
    $[50] = t17;
    $[51] = t18;
  } else {
    t18 = $[51];
  }
  return t18;
};
export default TeamSection;
function _temp(member, index) {
  return <li key={`${member.name}-${index}`} data-team-slide={true} className={css.slide} role="listitem">{member.image?.url ? <Image className={css.slideImage} src={member.image.url} width={400} height={600} alt={member.image.alternativeText ?? member.name} preload={false} /> : null}</li>;
}
function _temp2(member_0) {
  return member_0.image?.url ? <Image key={member_0.name} preload={true} src={member_0.image.url} width={400} height={600} alt={member_0.image?.alternativeText ?? member_0.name} /> : null;
}